export default "__VITE_ASSET__Cnk72VJB__"